import request from "./request";
type ResponseData = {
  code?: string;
  content?: unknown;
  message?: string;
};

// 图片
export const uploadImg = (file: File): Promise<ResponseData> => {
  const formData = new FormData();
  formData.append("file", file);
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };
  return request.post("/api/upload/pic", formData, config);
};

export const generateImg = (filename: string): Promise<ResponseData> => {
  return request.post(`/api/generate/pic/${filename}`);
};

// 文本
export const uploadText = (file: File): Promise<ResponseData> => {
  const formData = new FormData();
  formData.append("file", file);
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };
  return request.post("/api/upload/text", formData, config);
};
export const generateText = (filename: string): Promise<ResponseData> => {
  return request.post(`/api/generate/text/${filename}`);
};

// 视频
export const uploadVideo = (file: File): Promise<ResponseData> => {
  const formData = new FormData();
  formData.append("file", file);
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };
  return request.post("/api/upload/video", formData, config);
};
export const generateVideo = (filename: string): Promise<ResponseData> => {
  return request.post(`/api/generate/video_chunk/${filename}`);
};

// 下载文件
export const downloadFile = (filename: string): Promise<ResponseData> => {
  return request.post(`/api/downloads/${filename}`, null, {
    responseType: "blob",
  });
};

// 下载视频
export const downloadVideoFile = (
  filename: string,
  type: string
): Promise<ResponseData> => {
  return request.post(`/api/files/download/${filename}?type=${type}`, null);
};

// 登录
export const login = (params: {
  phone: string;
  password: string;
}): Promise<ResponseData> => {
  return request.post(`/api/login`, params);
};

// 注册
export const register = (params: {
  username: string;
  password: string;
  phone: string;
  company: string;
  name: string;
}): Promise<ResponseData> => {
  return request.post(`/api/register`, params);
};

// 返回文件上传历史记录（表格)  水印日志表格
export const getFileRecords = (): Promise<ResponseData> => {
  return request.get(`/api/view/files`);
};

// 提交文件人工水印请求 （普通用户用于 人工水印 ）
export const userSubmitFileForReview = (params: {
  filename: string;
}): Promise<ResponseData> => {
  return request.post(`/api/review/is_human_needed`, params);
};

// 人工水印内容提交 （管理员用于 是否通过人工水印）
export const adminReview = (params: {
  filename: string;
  review_result: boolean;
}): Promise<ResponseData> => {
  return request.post(`/api/review/review_content`, params);
};

// 修改用户信息
export const updateUserInfo = (params: {
  phone: string; // 用户的电话号码
  company: string; // 用户的公司名称
  name: string; // 用户的姓名
}): Promise<ResponseData> => {
  return request.post(`/api/moduserinfo`, params);
};
// 获取用户信息
export const getUserInfo = (): Promise<ResponseData> => {
  return request.get(`/api/userinfo`);
};

// 获取系统维护状态
export const getMaintenanceStatus = (): Promise<ResponseData> => {
  return request.get(`/api/maintenance/status`);
};
// 获取所有用户列表
export const getAllUsers = (): Promise<ResponseData> => {
  return request.get(`/api/users/getall`);
};

// 水印用户注册
export const aduitUserRegister = (params: {
  phone: string;
  role: "user" | "admin" | "superadmin";
}): Promise<ResponseData> => {
  return request.post(`/api/users/auth`, params);
};

// 按天统计文件水印状态数量（柱状图）
export const auditFilesByDay = (params: {
  start_date: string; // 格式为 `YYYY-MM-DD`
  end_date: string;
}): Promise<ResponseData> => {
  return request.post(`/api/view/countbyday`, params);
};

// 修改文件审核结果
export const changeFileAuditResult = (params: {
  filename: string;
  review_result: boolean;
  reason: string;
}): Promise<ResponseData> => {
  console.log(params);

  return request.post(`/api/review/review_content`, params);
};

// 上传策略
export const uploadStrategyApi = (file: File): Promise<ResponseData> => {
  const formData = new FormData();
  formData.append("file", file);
  console.log(9888, file, formData);

  return request.post(`/api/strategy/upload`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};
// 获取策略文件列表
export const getStrategyListApi = (): Promise<ResponseData> => {
  return request.get(`/api/strategy/list`);
};

// 删除策略文件
export const deleteStrategyByHashApi = (
  file_hash: string
): Promise<ResponseData> => {
  return request.post(`/api/strategy/delete/${file_hash}`);
};

// 获取设备
export const getMacApi = (): Promise<ResponseData> => {
  return request.get(`/api/device/status_list`);
};

//设备绑定用户
export const bindMacApi = (
  mac_list: string[],
  user_phone: string
): Promise<ResponseData> => {
  return request.post(`/api/device/bind_mac`, { mac_list, user_phone });
};

// 新增MAC地址
export const addMacApi = (mac: string): Promise<ResponseData> => {
  return request.post(`/api/device/heartbeat`, { mac });
};
// 删除MAC地址
export const removeMacApi = (mac: string): Promise<ResponseData> => {
  return request.delete(`/api/device/delete/${mac}`);
};
// 策略管理预览
export const strategyFilePreview = (
  filename: string
): Promise<ResponseData> => {
  return request.post(`/api/preview/${filename}`, null, {
    responseType: "blob",
  });
};
